<style>
  .focus {
    box-shadow: 0 0 6px 0 #0054be;
  }
  .focus + label::before {
    box-shadow: 0 0 6px 0 #0054be;
  }
  .btn-success__hover {
    background-color: #3f901d !important;
    border-color: #3f901d !important;
  }
  .btn-info__hover {
    background-color: #003d8b !important;
    border-color: #003d8b !important;
  }
  .btn-outline-danger__hover {
    color: white;
    background-color: #bd2130 !important;
    border-color: #bd2130 !important;
  }
  .btn-outline-info__hover {
    color: white;
    background-color: #003d8b !important;
    border-color: #003d8b !important;
  }
</style>

<p
  class="p-30 pb-0"
  style="
    color: #001e3c;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 38px;
  "
>
  Colors
</p>
<!-- /* Typography */ -->
<div class="card d-flex flex-row" style="gap: 15px">
  <div
    class="color-item d-flex flex-column align-items-center"
    style="width: 50px"
  >
    <div
      class="color-item__color"
      style="background: #856404; width: 50px; height: 50px"
    ></div>
    <div class="color-item__label">#856404</div>
  </div>
  <div
    class="color-item d-flex flex-column align-items-center"
    style="width: 50px"
  >
    <div
      class="color-item__color"
      style="background: #001e3c; width: 50px; height: 50px"
    ></div>
    <div class="color-item__label">#001E3C</div>
  </div>
  <div
    class="color-item d-flex flex-column align-items-center"
    style="width: 50px"
  >
    <div
      class="color-item__color"
      style="background: #004092; width: 50px; height: 50px"
    ></div>
    <div class="color-item__label">#004092</div>
  </div>
  <div
    class="color-item d-flex flex-column align-items-center"
    style="width: 50px"
  >
    <div
      class="color-item__color"
      style="background: #005092; width: 50px; height: 50px"
    ></div>
    <div class="color-item__label">#005092</div>
  </div>
  <div
    class="color-item d-flex flex-column align-items-center"
    style="width: 50px"
  >
    <div
      class="color-item__color"
      style="background: #7196c8; width: 50px; height: 50px"
    ></div>
    <div class="color-item__label">#7196C8</div>
  </div>
  <div
    class="color-item d-flex flex-column align-items-center"
    style="width: 50px"
  >
    <div
      class="color-item__color"
      style="background: #b1b1b1; width: 50px; height: 50px"
    ></div>
    <div class="color-item__label">#B1B1B1</div>
  </div>
  <div
    class="color-item d-flex flex-column align-items-center"
    style="width: 50px"
  >
    <div
      class="color-item__color"
      style="background: #7f98a8; width: 50px; height: 50px"
    ></div>
    <div class="color-item__label">#7F98A8</div>
  </div>
  <div
    class="color-item d-flex flex-column align-items-center"
    style="width: 50px"
  >
    <div
      class="color-item__color"
      style="background: #ecf3fa; width: 50px; height: 50px"
    ></div>
    <div class="color-item__label">#ECF3FA</div>
  </div>
  <div
    class="color-item d-flex flex-column align-items-center"
    style="width: 50px"
  >
    <div
      class="color-item__color"
      style="background: #efefef; width: 50px; height: 50px"
    ></div>
    <div class="color-item__label">#EFEFEF</div>
  </div>
  <div
    class="color-item d-flex flex-column align-items-center"
    style="width: 50px"
  >
    <div
      class="color-item__color"
      style="background: #f6f6f7; width: 50px; height: 50px"
    ></div>
    <div class="color-item__label">#F6F6F7</div>
  </div>
  <div
    class="color-item d-flex flex-column align-items-center"
    style="width: 50px"
  >
    <div
      class="color-item__color"
      style="background: #dc3545; width: 50px; height: 50px"
    ></div>
    <div class="color-item__label">#DC3545</div>
  </div>
  <div
    class="color-item d-flex flex-column align-items-center"
    style="width: 50px"
  >
    <div
      class="color-item__color"
      style="background: #ed6b06; width: 50px; height: 50px"
    ></div>
    <div class="color-item__label">#ED6B06</div>
  </div>
  <div
    class="color-item d-flex flex-column align-items-center"
    style="width: 50px"
  >
    <div
      class="color-item__color"
      style="background: #f8d62b; width: 50px; height: 50px"
    ></div>
    <div class="color-item__label">#F8D62B</div>
  </div>
  <div
    class="color-item d-flex flex-column align-items-center"
    style="width: 50px"
  >
    <div
      class="color-item__color"
      style="background: #ffeeba; width: 50px; height: 50px"
    ></div>
    <div class="color-item__label">#FFEEBA</div>
  </div>
  <div
    class="color-item d-flex flex-column align-items-center"
    style="width: 50px"
  >
    <div
      class="color-item__color"
      style="background: #51bb25; width: 50px; height: 50px"
    ></div>
    <div class="color-item__label">#51BB25</div>
  </div>
  <div
    class="color-item d-flex flex-column align-items-center"
    style="width: 50px"
  >
    <div
      class="color-item__color"
      style="background: #98da76; width: 50px; height: 50px"
    ></div>
    <div class="color-item__label">#98DA76</div>
  </div>
</div>

<p
  class="p-30 pb-0"
  style="
    color: #001e3c;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 38px;
  "
>
  Typography
</p>
<!-- /* Typography */ -->
<div class="card d-flex flex-row">
  <div>
    <h1>Heading 1</h1>
    <h2>Heading 2</h2>
    <h3>Heading 3</h3>
    <h4>Heading 4</h4>
    <p class="body-heading">Body Heading 1</p>
    <p>Body 1</p>
  </div>
  <div class="ml-5">
    <h1>Yeni Provizyon</h1>
    <h2>Provizyon Türü</h2>
    <h3>İşlem 1</h3>
    <h4>ICD Kodu ve Teşhis Listesi</h4>
    <p class="body-heading">Bilgilendirme 1</p>
    <p>Üyelerimizin</p>
  </div>
</div>

<p
  class="p-30 pb-0"
  style="
    color: #001e3c;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 38px;
  "
>
  Forms
</p>
<!-- /* Forms */ -->
<div class="card">
  <div class="row">
    <div class="col-lg-5">
      <form class="theme-form">
        <p
          style="
            font-size: 18px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 23px;
            color: #0054be;
          "
        >
          Default Fields
        </p>
        <div class="form-group mb-3">
          <label class="label">E-Posta</label>
          <input type="text" placeholder="Giriş Yapınız" class="form-control" />
        </div>
        <div class="form-group mb-3">
          <label class="label">Dropdown</label>
          <select class="form-control" required>
            <option value="" default selected hidden>Seçiniz</option>
            <option>Seçim 1</option>
            <option>Seçim 2</option>
            <option>Seçim 3</option>
          </select>
        </div>
        <div class="form-group mb-3">
          <label class="label">Date</label>
          <mat-form-field class="example-full-width" appearance="fill">
            <input placeholder="01/01/2022" matInput [matDatepicker]="picker" />
            <mat-datepicker-toggle matSuffix [for]="picker">
              <mat-icon matDatepickerToggleIcon>date_range</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="form-group mb-3">
          <label class="label">Input Area</label>
          <textarea
            rows="5"
            class="form-control"
            placeholder="Giriş Yapınız"
          ></textarea>
        </div>
        <div class="form-group mb-3 d-flex">
          <div class="radio radio-primary">
            <input id="radio1" type="radio" name="radio1" value="option1" />
            <label for="radio1">Option<span class="digits"> 1</span></label>
          </div>
          <div class="checkbox ml-5">
            <input id="checkbox1" type="checkbox" />
            <label for="checkbox1">Default</label>
          </div>
        </div>
      </form>
      <form class="theme-form">
        <p
          style="
            font-size: 18px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 23px;
            color: #0054be;
          "
        >
          Clicked Fields
        </p>
        <div class="form-group mb-3">
          <label class="label">E-Posta</label>
          <input
            type="text"
            placeholder="Giriş Yapınız"
            class="form-control focus"
          />
        </div>
        <div class="form-group mb-3">
          <label class="label">Dropdown</label>
          <select class="form-control focus" required>
            <option value="" default selected hidden>Seçiniz</option>
            <option>Seçim 1</option>
            <option>Seçim 2</option>
            <option>Seçim 3</option>
          </select>
        </div>
        <div class="form-group mb-3">
          <label class="label">Input Area</label>
          <textarea
            rows="5"
            class="form-control focus"
            placeholder="Giriş Yapınız"
          ></textarea>
        </div>
        <div class="form-group mb-3 d-flex">
          <div class="radio radio-primary">
            <input
              id="radio11"
              type="radio"
              name="radio11"
              value="option11"
              class="focus"
              checked
            />
            <label for="radio11">Option<span class="digits"> 1</span></label>
          </div>
          <div class="checkbox ml-5">
            <input id="checkbox11" type="checkbox" class="focus" checked />
            <label for="checkbox11">Default</label>
          </div>
        </div>
      </form>
    </div>
    <div class="col-lg-1"></div>
    <div class="col-lg-5">
      <form class="theme-form">
        <p
          style="
            font-size: 18px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 23px;
            color: #0054be;
          "
        >
          Full Fields
        </p>
        <div class="form-group mb-3">
          <label class="label">E-Posta</label>
          <input
            type="text"
            placeholder="Giriş Yapınız"
            class="form-control"
            value="test@hotmail.com"
          />
        </div>
        <div class="form-group mb-3">
          <label class="label">Dropdown</label>
          <select class="form-control" required>
            <option value="" default hidden>Seçiniz</option>
            <option>Seçim 1</option>
            <option selected>Seçim 2</option>
            <option>Seçim 3</option>
          </select>
        </div>

        <div class="form-group mb-3">
          <label class="label">Input Area</label>
          <textarea rows="5" class="form-control" placeholder="Giriş Yapınız">
Giriş Yapınız</textarea
          >
        </div>
        <div class="form-group mb-3 d-flex">
          <div class="radio radio-primary">
            <input
              id="radio12"
              type="radio"
              name="radio12"
              value="option1"
              checked
            />
            <label for="radio12">Option<span class="digits"> 1</span></label>
          </div>
          <div class="checkbox ml-5">
            <input id="checkbox12" type="checkbox" checked />
            <label for="checkbox12">Default</label>
          </div>
        </div>
      </form>
      <form class="theme-form">
        <p
          style="
            font-size: 18px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 23px;
            color: #0054be;
          "
        >
          Disabled Fields
        </p>
        <div class="form-group mb-3">
          <label class="label">E-Posta</label>
          <input
            type="text"
            placeholder="Giriş Yapınız"
            class="form-control"
            disabled
          />
        </div>
        <div class="form-group mb-3">
          <label class="label">Dropdown</label>
          <select class="form-control" required disabled>
            <option value="" default selected hidden>Seçiniz</option>
            <option>Seçim 1</option>
            <option>Seçim 2</option>
            <option>Seçim 3</option>
          </select>
        </div>
        <div class="form-group mb-3">
          <label class="label">Input Area</label>
          <textarea
            rows="5"
            class="form-control"
            placeholder="Giriş Yapınız"
            disabled
          ></textarea>
        </div>
        <div class="form-group mb-3 d-flex">
          <div class="radio radio-primary">
            <input
              id="radio11"
              type="radio"
              name="radio11"
              value="option11"
              disabled
            />
            <label for="radio11">Option<span class="digits"> 1</span></label>
          </div>
          <div class="checkbox ml-5">
            <input id="checkbox11" type="checkbox" disabled />
            <label for="checkbox11">Default</label>
          </div>
        </div>
        <div class="form-group mb-3 d-flex">
          <div class="radio radio-primary">
            <input
              id="radio11"
              type="radio"
              name="radio11"
              value="option11"
              checked
              disabled
            />
            <label for="radio11">Option<span class="digits"> 1</span></label>
          </div>
          <div class="checkbox ml-5">
            <input id="checkbox11" type="checkbox" checked disabled />
            <label for="checkbox11">Default</label>
          </div>
        </div>
      </form>
    </div>
    <div class="col-lg-1"></div>
  </div>

  <p
    style="
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 23px;
      color: #0054be;
    "
  >
    Others
  </p>

  <div class="form-group mb-3">
    <div class="row mb-3">
      <div class="col-6">
        <label class="label">Tab Radio Button</label>
        <div class="m-checkbox-inline">
          <div class="radio radio-primary">
            <input
              id="radioinline1"
              type="radio"
              name="radio1"
              value="option1"
              checked
            />
            <label class="mb-0" for="radioinline1">Teminat</label>
            <div class="checked-background"></div>
          </div>
          <div class="radio radio-primary">
            <input
              id="radioinline2"
              type="radio"
              name="radio1"
              value="option1"
            />
            <label class="mb-0" for="radioinline2">İlaç</label>
            <div class="checked-background"></div>
          </div>
          <div class="radio radio-primary">
            <input
              id="radioinline3"
              type="radio"
              name="radio1"
              value="option1"
            />
            <label class="mb-0" for="radioinline3">Malzeme</label>
            <div class="checked-background"></div>
          </div>
          <div class="radio radio-primary">
            <input
              id="radioinline4"
              type="radio"
              name="radio1"
              value="option1"
            />
            <label class="mb-0" for="radioinline4">Diğer</label>
            <div class="checked-background"></div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <label class="label">Breadcrumb</label>

        <ol class="breadcrumb m-b-0 bg-white p-l-0">
          <li class="breadcrumb-item active">Home</li>
        </ol>
        <ol class="breadcrumb m-b-0 bg-white p-l-0">
          <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
          <li class="breadcrumb-item active">Library</li>
        </ol>
      </div>
    </div>

    <label class="label">Grid</label>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">İşlem No</th>
            <th scope="col">Teminat</th>
            <th scope="col">Kod</th>
            <th scope="col">Ad</th>
            <th scope="col">Ödenen Tutar (KDV'li)</th>
            <th scope="col">Ödenen Tutar (KDV'siz)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1331218</td>
            <td>Radyoloji</td>
            <td>10.0030</td>
            <td>Bronoskopi, Bronkoalveolar lavaj</td>
            <td>4.246,32</td>
            <td>4.000,00</td>
          </tr>
          <tr>
            <td>1331254</td>
            <td>İlaç</td>
            <td>20.9994</td>
            <td>İlaç</td>
            <td>1.783,78</td>
            <td>1.651,83</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<p
  class="p-30 pb-0"
  style="
    color: #001e3c;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 38px;
  "
>
  Buttons
</p>
<!-- /* Typography */ -->
<div class="d-flex flex-row" style="gap: 30px">
  <div class="card flex-fill">
    <div>
      <p
        style="
          font-size: 18px;
          font-weight: 600;
          letter-spacing: 0;
          line-height: 23px;
          color: #0054be;
        "
      >
        Default
      </p>
      <div class="d-flex flex-column">
        <div class="mb-3">
          <button class="btn btn-warning"><span>Information</span></button>
        </div>
        <div class="mb-3">
          <button class="btn btn-success"><span>Primary</span></button>
        </div>
        <div class="mb-3">
          <button class="btn btn-info"><span>Secondary</span></button>
        </div>
      </div>
    </div>
  </div>
  <div class="card flex-fill">
    <div>
      <p
        style="
          font-size: 18px;
          font-weight: 600;
          letter-spacing: 0;
          line-height: 23px;
          color: #0054be;
        "
      >
        Disabled
      </p>
      <div class="d-flex flex-column">
        <div class="mb-3">
          <button class="btn btn-success" disabled><span>Primary</span></button>
        </div>
        <div class="mb-3">
          <button class="btn btn-info" disabled><span>Secondary</span></button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="d-flex flex-row" style="gap: 30px">
  <div class="card flex-fill">
    <div>
      <p
        style="
          font-size: 18px;
          font-weight: 600;
          letter-spacing: 0;
          line-height: 23px;
          color: #0054be;
        "
      >
        Hover
      </p>
      <div class="d-flex flex-column">
        <div class="d-flex flex-row mb-3">
          <button
            id="btn-success-hover"
            class="btn btn-success btn-success__hover"
          >
            <span>Primary</span>
          </button>
          <button class="btn btn-success m-l-15"><span>Primary</span></button>
        </div>
        <div class="mb-3">
          <button class="btn btn-info btn-info__hover">
            <span>Secondary</span>
          </button>
          <button class="btn btn-info m-l-15"><span>Secondary</span></button>
        </div>
        <div class="mb-3">
          <button class="btn btn-outline-danger btn-outline-danger__hover">
            <span class="far fa-trash-alt">&nbsp;&nbsp;</span><span>2</span
            ><span>&nbsp;İşlem Sil</span>
          </button>
          <button class="btn btn-outline-danger m-l-15">
            <span class="far fa-trash-alt">&nbsp;&nbsp;</span><span>2</span
            ><span>&nbsp;İşlem Sil</span>
          </button>
        </div>
        <div class="mb-3">
          <button class="btn btn-outline-info btn-outline-info__hover">
            <span class="far fa-plus">&nbsp;&nbsp;</span
            ><span>Teşhis/Hizmet Ekle</span>
          </button>
          <button class="btn btn-outline-info m-l-15">
            <span class="far fa-plus">&nbsp;&nbsp;</span
            ><span>Teşhis/Hizmet Ekle</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="card flex-fill">
    <div>
      <p
        style="
          font-size: 18px;
          font-weight: 600;
          letter-spacing: 0;
          line-height: 23px;
          color: #0054be;
        "
      >
        Ghost
      </p>
      <div class="d-flex flex-column">
        <div class="mb-3">
          <button class="btn btn-outline-info">
            <span class="far fa-plus">&nbsp;&nbsp;</span
            ><span>Teşhis/Hizmet Ekle</span>
          </button>
        </div>
        <div class="mb-3">
          <button class="btn btn-outline-danger">
            <span class="far fa-trash-alt">&nbsp;&nbsp;</span><span>2</span
            ><span>&nbsp;İşlem Sil</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<p
  class="p-30 pb-0"
  style="
    color: #001e3c;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 38px;
  "
>
  Pagination
</p>
<!-- /* Typography */ -->
<div class="card d-flex flex-row">
  <ngb-pagination
    [collectionSize]="90"
    [(page)]="page"
    [maxSize]="5"
    [rotate]="true"
    aria-label="Default pagination"
  ></ngb-pagination>
  <form class="theme-form m-l-30">
    <div class="form-group">
      <select class="form-control pagination-select">
        <option selected>5</option>
        <option>10</option>
        <option>15</option>
        <option>20</option>
      </select>
    </div>
  </form>
</div>

<p
  class="p-30 pb-0"
  style="
    color: #001e3c;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 38px;
  "
>
  Toast Message
</p>
<!-- /* Typography */ -->
<div class="card d-inline-flex" style="gap: 15px">
  <button class="btn btn-outline-primary" (click)="messageSuccess()">
    <span>Success</span>
  </button>
  <button class="btn btn-outline-primary" (click)="messageError()">
    <span>Error</span>
  </button>
  <button class="btn btn-outline-primary" (click)="messageWarning()">
    <span>Warning</span>
  </button>
</div>

<p
  class="p-30 pb-0"
  style="
    color: #001e3c;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 38px;
  "
>
  Tooltip
</p>
<!-- /* Typography */ -->
<div class="card d-inline-flex" style="gap: 15px">
  <span
    class="fas fa-exclamation-circle warning-tooltip-icon"
    placement="right"
    ngbTooltip="SHY’li üyeden SGK/Katkı payı peşin alınmalıdır."
  ></span>
</div>

<p
  class="p-30 pb-0"
  style="
    color: #001e3c;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 38px;
  "
>
  Date Pickers
</p>
<!-- /* Typography */ -->
<div class="card w-25">
  <mat-form-field class="example-full-width" appearance="fill">
    <input placeholder="01/01/2022" matInput [matDatepicker]="picker" />
    <mat-datepicker-toggle matSuffix [for]="picker">
      <mat-icon matDatepickerToggleIcon>date_range</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>

<p
  class="p-30 pb-0"
  style="
    color: #001e3c;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 38px;
  "
>
  Icons
</p>
<!-- /* Typography */ -->
<div class="card d-flex flex-row">
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #0073b9;
    "
  >
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>6D0C2A0A-9A27-437C-8D14-D9CFCA8CFE5C</title>
      <defs>
        <rect id="path-1" x="0" y="0" width="16" height="16"></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-161.000000, -4879.000000)">
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <g
              id="icon/Provizyon_Kontrol/Default"
              transform="translate(17.000000, 17.000000)"
            >
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
              </mask>
              <g id="Canvas"></g>
              <path
                d="M2.66666667,2 C1.9313333,2 1.33333333,2.59799997 1.33333333,3.33333333 L1.33333333,12.6666667 C1.33333333,13.402 1.9313333,14 2.66666667,14 L13.3333333,14 C14.0686667,14 14.6666667,13.402 14.6666667,12.6666667 L14.6666667,3.33333333 C14.6666667,2.59799997 14.0686667,2 13.3333333,2 L2.66666667,2 Z M2.66666667,4.66666667 L13.3333333,4.66666667 L13.3339996,12.6666667 L2.66666667,12.6666667 L2.66666667,4.66666667 Z M7.33331235,10.7473323 L4.86197917,8.2759997 L5.80464554,7.33333333 L7.33331235,8.86200015 L10.1953125,6 L11.1379801,6.94266637 L7.33331235,10.7473323 Z"
                id="Provizyon_Kontrol"
                fill="#FFFFFF"
                mask="url(#mask-2)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #0073b9;
    "
  >
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>B8D08224-1C8D-4D1C-9B5D-C77ABC932299</title>
      <defs>
        <rect id="path-1" x="0" y="0" width="16" height="16"></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-231.000000, -4879.000000)">
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <g
              id="icon/Provizyon_Paket/Default"
              transform="translate(87.000000, 17.000000)"
            >
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
              </mask>
              <g id="Canvas"></g>
              <path
                d="M13.3333333,14 C14.0686667,14 14.6666667,13.402 14.6666667,12.6666667 L14.6666667,3.33333333 C14.6666667,2.59799997 14.0686667,2 13.3333333,2 L2.66666667,2 C1.9313333,2 1.33333333,2.59799997 1.33333333,3.33333333 L1.33333333,12.6666667 C1.33333333,13.402 1.9313333,14 2.66666667,14 L13.3333333,14 Z M2.66666667,4.66666667 L13.3333333,4.66666667 L13.3339996,12.6666667 L2.66666667,12.6666667 L2.66666667,4.66666667 Z"
                id="Provizyon_Paket"
                fill="#FFFFFF"
                mask="url(#mask-2)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #0073b9;
    "
  >
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>73C35855-628F-4E43-9D1B-279B4F4F6EDF</title>
      <defs>
        <rect id="path-1" x="0" y="0" width="16" height="16"></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-301.000000, -4879.000000)">
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <g
              id="icon/Provizyon_Iade/Default-Copy"
              transform="translate(157.000000, 17.000000)"
            >
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
              </mask>
              <g id="Canvas"></g>
              <path
                d="M13.3333333,2 C14.0686667,2 14.6666667,2.59799997 14.6666667,3.33333333 L14.6666667,12.6666667 C14.6666667,13.402 14.0686667,14 13.3333333,14 L2.66666667,14 C1.9313333,14 1.33333333,13.402 1.33333333,12.6666667 L1.33333333,3.33333333 C1.33333333,2.59799997 1.9313333,2 2.66666667,2 Z M13.3333333,4.66666667 L2.66666667,4.66666667 L2.66666667,12.6666667 L13.3339996,12.6666667 L13.3333333,4.66666667 Z M7.6917873,5.99999909 L8.39889478,6.70710617 L6.60606511,8.49994983 L11.3365466,8.49995232 L11.3365465,9.49995232 L6.60597347,9.49994959 L8.39891727,11.2928926 L7.69180967,11.9999991 L4.69180993,8.99999883 L7.6917873,5.99999909 Z"
                id="Provizyon_Iade"
                fill="#FFFFFF"
                mask="url(#mask-2)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #0073b9;
    "
  >
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>485845B8-5EAD-4E1D-9AF8-583A47A02B46</title>
      <defs>
        <rect id="path-1" x="0" y="0" width="16" height="16"></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-371.000000, -4879.000000)">
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <g
              id="icon/Bill/Default"
              transform="translate(227.000000, 17.000000)"
            >
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
              </mask>
              <g id="Canvas"></g>
              <path
                d="M12.1365369,1.5 L3.86442897,1.5 C2.55912638,1.5 1.50096955,2.55815683 1.50096955,3.86345942 L1.50096955,7.99951341 C1.50096955,8.32583906 1.76550876,8.59037826 2.09183441,8.59037826 L5.04615868,8.59037826 L5.04615868,13.908162 C5.04558764,14.1389366 5.17942575,14.348924 5.3888603,14.445849 C5.59879911,14.5424957 5.84581438,14.5078673 6.0210857,14.3572193 L7.70505053,12.915509 L9.38901537,14.3572193 C9.61013119,14.5463478 9.93602387,14.5463478 10.1571397,14.3572193 L11.8411045,12.915509 L13.5250694,14.3572193 C13.6320997,14.4487475 13.7683021,14.4990377 13.9091315,14.4990268 C13.9946149,14.4984224 14.0790696,14.480325 14.1572948,14.445849 C14.3667293,14.348924 14.5005674,14.1389366 14.4999982,13.908162 L14.4999982,3.86345942 C14.4999982,2.55815683 13.4418395,1.5 12.1365369,1.5 Z M2.68269926,7.40864855 L2.68269926,3.86345942 C2.68269926,3.21080812 3.21177768,2.68172971 3.86442897,2.68172971 C4.51708027,2.68172971 5.04615868,3.21080812 5.04615868,3.86345942 L5.04615868,7.40864855 L2.68269926,7.40864855 Z M13.3182667,12.6259852 L12.2251667,11.6865101 C12.0040509,11.4973815 11.6781582,11.4973815 11.4570424,11.6865101 L9.77307753,13.1282204 L8.08911269,11.6865101 C7.86799687,11.4973815 7.5421042,11.4973815 7.32098838,11.6865101 L6.2278884,12.6259852 L6.2278884,3.86345942 C6.22715178,3.44836529 6.11710538,3.04078604 5.90882137,2.68172971 L12.1365369,2.68172971 C12.7891882,2.68172971 13.3182667,3.21080812 13.3182667,3.86345942 L13.3182667,12.6259852 Z M12.1365369,4.45432428 C12.1365369,4.78064993 11.8719977,5.04518913 11.5456721,5.04518913 L8.00048296,5.04518913 C7.67415731,5.04518913 7.40961811,4.78064993 7.40961811,4.45432428 C7.40961811,4.12799863 7.67415731,3.86345942 8.00048296,3.86345942 L11.5456721,3.86345942 C11.8719977,3.86345942 12.1365369,4.12799863 12.1365369,4.45432428 Z M12.1365369,6.8177837 C12.1365369,7.14410935 11.8719977,7.40864855 11.5456721,7.40864855 L8.00048296,7.40864855 C7.67415731,7.40864855 7.40961811,7.14410935 7.40961811,6.8177837 C7.40961811,6.49145805 7.67415731,6.22691884 8.00048296,6.22691884 L11.5456721,6.22691884 C11.8719977,6.22691884 12.1365369,6.49145805 12.1365369,6.8177837 Z M12.1365369,9.18124312 C12.1365369,9.50756877 11.8719977,9.77210798 11.5456721,9.77210798 L8.00048296,9.77210798 C7.67415731,9.77210798 7.40961811,9.50756877 7.40961811,9.18124312 C7.40961811,8.85491747 7.67415731,8.59037826 8.00048296,8.59037826 L11.5456721,8.59037826 C11.8719977,8.59037826 12.1365369,8.85491747 12.1365369,9.18124312 Z"
                id="Bill"
                fill="#FFFFFF"
                fill-rule="nonzero"
                mask="url(#mask-2)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #0073b9;
    "
  >
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>2458C531-5B64-4CD9-BF8F-AABD9F6F9C9C</title>
      <defs>
        <rect id="path-1" x="0" y="0" width="16" height="16"></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-441.000000, -4879.000000)">
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <g
              id="icon/User/Default"
              transform="translate(297.000000, 17.000000)"
            >
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
              </mask>
              <g id="Canvas"></g>
              <path
                d="M4.66666667,5.42105263 C4.66666667,7.30742103 6.16200002,8.84210526 8,8.84210526 C9.83799998,8.84210526 11.3333333,7.30742103 11.3333333,5.42105263 C11.3333333,3.53468423 9.83799998,2 8,2 C6.16200002,2 4.66666667,3.53468423 4.66666667,5.42105263 Z M6,5.42105263 C6,4.28936839 6.8973333,3.36842105 8,3.36842105 C9.1026667,3.36842105 10,4.28936839 10,5.42105263 C10,6.55273687 9.1026667,7.47368421 8,7.47368421 C6.8973333,7.47368421 6,6.55273687 6,5.42105263 Z M14,14.3157895 C14,11.6754211 11.906,9.52631579 9.33333333,9.52631579 L6.66666667,9.52631579 C4.0933334,9.52631579 2,11.6754211 2,14.3157895 L2,15 L3.33333333,15 L3.33333333,14.3157895 C3.33333333,12.4294211 4.82866669,10.8947368 6.66666667,10.8947368 L9.33333333,10.8947368 C11.1713333,10.8947368 12.6666667,12.4294211 12.6666667,14.3157895 L12.6666667,15 L14,15 L14,14.3157895 Z"
                id="user-/-user"
                fill="#FFFFFF"
                mask="url(#mask-2)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #0073b9;
    "
  >
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>D72A5D3A-4C3C-4B1C-B4CD-B65E081648F3</title>
      <defs>
        <rect id="path-1" x="0" y="0" width="16" height="16"></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-511.000000, -4879.000000)">
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <g id="icon/Document" transform="translate(367.000000, 17.000000)">
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
              </mask>
              <g id="Canvas"></g>
              <path
                d="M13.1181,5.571 C13.1706,5.669 13.2,5.781 13.2,5.9 L13.2,12.2 C13.2,13.7463 11.947,15 10.4,15 L2.7,15 C2.3136,15 2,14.6864 2,14.3 L2,1.7 C2,1.3136 2.3136,1 2.7,1 L8.3,1 C8.419,1 8.531,1.0294 8.629,1.0819 L8.6311,1.0833 C8.6857,1.112 8.7368,1.1491 8.783,1.1932 L8.7949,1.2051 C8.7949,1.2051 12.9949,5.4051 12.9949,5.4051 L13.0068,5.417 C13.0516,5.4639 13.088,5.515 13.1174,5.5689 L13.1181,5.571 Z M7.6,2.4 L3.4,2.4 L3.4,13.6 L10.4,13.6 C11.1735,13.6 11.8,12.9735 11.8,12.2 L11.8,6.6 L8.3,6.6 C7.9136,6.6 7.6,6.2864 7.6,5.9 L7.6,2.4 Z M6.2,12.2 L9,12.2 C9.3864,12.2 9.7,11.8864 9.7,11.5 C9.7,11.1136 9.3864,10.8 9,10.8 L6.2,10.8 C5.8136,10.8 5.5,11.1136 5.5,11.5 C5.5,11.8864 5.8136,12.2 6.2,12.2 Z M5.5,9.4 L9.7,9.4 C10.0864,9.4 10.4,9.0864 10.4,8.7 C10.4,8.3136 10.0864,8 9.7,8 L5.5,8 C5.1136,8 4.8,8.3136 4.8,8.7 C4.8,9.0864 5.1136,9.4 5.5,9.4 Z M10.8102,5.2 L9,3.3898 L9,5.2 L10.8102,5.2 Z"
                id="Document"
                fill="#FFFFFF"
                mask="url(#mask-2)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #0073b9;
    "
  >
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>60069F86-4706-49FF-92A4-EC56117B6D0C</title>
      <defs>
        <rect id="path-1" x="0" y="0" width="16" height="16"></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-581.000000, -4879.000000)">
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <g id="icon/Home" transform="translate(437.000000, 17.000000)">
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
              </mask>
              <g id="Canvas"></g>
              <path
                d="M13.628,4.06733333 L8.96133333,1.57333333 C8.35933333,1.25133333 7.64066667,1.25133333 7.038,1.57333333 L2.37133333,4.06733333 C1.73133333,4.40933333 1.33333333,5.06466667 1.33333333,5.77666667 L1.33333333,12.718 C1.33333333,13.792 2.23066667,14.6666667 3.33333333,14.6666667 L5.33333333,14.6666667 L10.6666667,14.6666667 L12.6666667,14.6666667 C13.7693333,14.6666667 14.6666667,13.792 14.6666667,12.7173333 L14.6666667,5.77666667 C14.6666667,5.06466667 14.2686667,4.40933333 13.628,4.06733333 Z M6.66666667,13.3333333 L6.66666667,10.6666667 C6.66666667,9.93133333 7.26466667,9.33333333 8,9.33333333 C8.73533333,9.33333333 9.33333333,9.93133333 9.33333333,10.6666667 L9.33333333,13.3333333 L6.66666667,13.3333333 Z M13.3333333,12.7173333 C13.3333333,13.0566667 13.034,13.3333333 12.6666667,13.3333333 L10.6666667,13.3333333 L10.6666667,10.6666667 C10.6666667,9.196 9.47066667,8 8,8 C6.52933333,8 5.33333333,9.196 5.33333333,10.6666667 L5.33333333,13.3333333 L3.33333333,13.3333333 C2.966,13.3333333 2.66666667,13.0566667 2.66666667,12.7173333 L2.66666667,5.77666667 C2.66666667,5.55733333 2.794,5.35333333 3,5.24333333 L7.66666667,2.74933333 C7.76933333,2.69466667 7.88466667,2.66666667 8,2.66666667 C8.11533333,2.66666667 8.23066667,2.69466667 8.33333333,2.74933333 L13,5.24333333 C13.206,5.35333333 13.3333333,5.55733333 13.3333333,5.77666667 L13.3333333,12.7173333 Z"
                id="Shape"
                fill="#FFFFFF"
                fill-rule="nonzero"
                mask="url(#mask-2)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #0073b9;
    "
  >
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>3600BA7D-81BE-461A-8A2E-09605899CDCF</title>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Style-Sheet"
          transform="translate(-651.000000, -4879.000000)"
          fill="#FFFFFF"
        >
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <path
              d="M515,17 C519.418278,17 523,20.581722 523,25 C523,29.418278 519.418278,33 515,33 C510.581722,33 507,29.418278 507,25 C507,20.581722 510.581722,17 515,17 Z M515.137931,28.0344828 C514.604691,28.0344828 514.172414,28.4667596 514.172414,29 C514.172414,29.5332404 514.604691,29.9655172 515.137931,29.9655172 C515.671171,29.9655172 516.103448,29.5332404 516.103448,29 C516.103448,28.4667596 515.671171,28.0344828 515.137931,28.0344828 Z M515.137931,20.3103448 C514.604691,20.3103448 514.172414,20.7426216 514.172414,21.2758621 L514.172414,25.9655172 C514.172414,26.4987577 514.604691,26.9310345 515.137931,26.9310345 C515.671171,26.9310345 516.103448,26.4987577 516.103448,25.9655172 L516.103448,21.2758621 C516.103448,20.7426216 515.671171,20.3103448 515.137931,20.3103448 Z"
              id="icon/info"
              transform="translate(515.000000, 25.000000) scale(1, -1) translate(-515.000000, -25.000000) "
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </div>

  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>4D60D6EE-5CF1-43FF-8B81-3EC46D75F94E</title>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Style-Sheet"
          transform="translate(-721.000000, -4879.000000)"
          fill="#ED6B06"
        >
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <path
              d="M585,17 C589.418278,17 593,20.581722 593,25 C593,29.418278 589.418278,33 585,33 C580.581722,33 577,29.418278 577,25 C577,20.581722 580.581722,17 585,17 Z M585.137931,28.0344828 C584.604691,28.0344828 584.172414,28.4667596 584.172414,29 C584.172414,29.5332404 584.604691,29.9655172 585.137931,29.9655172 C585.671171,29.9655172 586.103448,29.5332404 586.103448,29 C586.103448,28.4667596 585.671171,28.0344828 585.137931,28.0344828 Z M585.137931,20.3103448 C584.604691,20.3103448 584.172414,20.7426216 584.172414,21.2758621 L584.172414,25.9655172 C584.172414,26.4987577 584.604691,26.9310345 585.137931,26.9310345 C585.671171,26.9310345 586.103448,26.4987577 586.103448,25.9655172 L586.103448,21.2758621 C586.103448,20.7426216 585.671171,20.3103448 585.137931,20.3103448 Z"
              id="icon/warning"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="16px"
      height="15px"
      viewBox="0 0 16 15"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>306C23C8-85EA-4E66-929C-4039EADFCF78</title>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Style-Sheet"
          transform="translate(-791.000000, -4879.000000)"
          fill="#7F98A8"
          fill-rule="nonzero"
        >
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <path
              d="M660.72075,17.21975 C661.01375,16.92675 661.48875,16.92675 661.78175,17.21975 C662.07275,17.51375 662.07275,17.98875 661.77975,18.28175 L648.27975,31.78175 C648.13375,31.92875 647.94175,32.00175 647.74975,32.00175 C647.55775,32.00175 647.36575,31.92775 647.21975,31.78175 C646.92675,31.48875 646.92675,31.01375 647.21975,30.72075 L649.70375,28.23675 C648.57375,27.39175 647.64375,26.28375 647.00075,25.00075 C648.48675,22.03275 651.51175,20.00075 655.00075,20.00075 C655.89075,20.00075 656.74975,20.13275 657.56175,20.37875 Z M659.97075,21.53075 C661.24975,22.39975 662.29875,23.59475 663.00175,24.99975 C661.51575,27.96775 658.49075,29.99975 655.00175,29.99975 C653.95675,29.99975 652.95275,29.81675 652.01975,29.48175 L653.22075,28.28075 C653.79975,28.42575 654.39775,28.49975 655.00175,28.49975 C656.40075,28.49975 657.76475,28.10075 658.94575,27.34775 C659.88575,26.74875 660.68275,25.94575 661.28075,24.99975 C660.68275,24.05475 659.88575,23.25175 658.94575,22.65175 C658.92675,22.63875 658.90675,22.62675 658.88675,22.61475 Z M658.81275,22.68875 C658.93575,23.07275 659.00175,23.48175 659.00175,23.90575 C659.00175,26.11475 657.21075,27.90575 655.00175,27.90575 C654.57775,27.90575 654.16875,27.83975 653.78475,27.71675 Z M651.24275,22.53775 C651.18075,22.57475 651.11875,22.61275 651.05775,22.65175 C650.11775,23.25075 649.32075,24.05375 648.72275,24.99975 C649.26075,25.85075 649.96075,26.58575 650.77975,27.16175 L651.73175,26.20975 C651.27175,25.55875 651.00175,24.76475 651.00175,23.90675 C651.00175,23.42575 651.08675,22.96475 651.24275,22.53775 Z M653.50175,21.99975 C652.67375,21.99975 652.00175,22.67175 652.00175,23.49975 C652.00175,24.15975 652.42875,24.71975 653.02075,24.92075 L654.92275,23.01875 C654.72175,22.42575 654.16175,21.99975 653.50175,21.99975 Z"
              id="icon/eyes_hide"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>58747030-1BC1-4AC9-AD83-36CCF954DDF8</title>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Style-Sheet"
          transform="translate(-861.000000, -4879.000000)"
          fill="#7F98A8"
          fill-rule="nonzero"
        >
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <g
              id="icon/password_reset"
              transform="translate(717.000000, 17.000000)"
            >
              <path
                d="M9.16666667,4.66666667 L8.66666667,4.66666667 L8.66666667,3.33333333 C8.66666667,1.49533333 7.17133333,0 5.33333333,0 C3.49533333,0 2,1.49533333 2,3.33333333 L2,4.66666667 L1.5,4.66666667 C0.673333333,4.66666667 0,5.34 0,6.16666667 L0,11.8333333 C0,12.66 0.673333333,13.3333333 1.5,13.3333333 L8.03333333,13.3333333 C8.1,12.9533333 8.29333333,12.6133333 8.56,12.3466667 C8.12,11.7466667 8.02666667,10.92 8.40666667,10.22 C8.92,9.26666667 9.72,8.53333333 10.6666667,8.10666667 L10.6666667,6.16666667 C10.6666667,5.34 9.99333333,4.66666667 9.16666667,4.66666667 Z M3.33333333,3.33333333 C3.33333333,2.23066667 4.23066667,1.33333333 5.33333333,1.33333333 C6.436,1.33333333 7.33333333,2.23066667 7.33333333,3.33333333 L7.33333333,4.66666667 L3.33333333,4.66666667 L3.33333333,3.33333333 Z"
                id="Shape"
              ></path>
              <path
                d="M15.484,13.2533333 C15.16,13.0786667 14.756,13.1986667 14.5806667,13.522 C14.198,14.228 13.4646667,14.6666667 12.6666667,14.6666667 C12.2593333,14.6666667 11.8733333,14.5433333 11.536,14.3373333 L11.8533333,14.02 C11.996,13.8773333 12.0393333,13.662 11.962,13.4753333 C11.8846667,13.2886667 11.702,13.1666667 11.5,13.1666667 L9.83333333,13.1666667 C9.55733333,13.1666667 9.33333333,13.3906667 9.33333333,13.6666667 L9.33333333,15.3333333 C9.33333333,15.5353333 9.45533333,15.718 9.642,15.7953333 C9.704,15.8213333 9.76866667,15.8333333 9.83333333,15.8333333 C9.96333333,15.8333333 10.0913333,15.7826667 10.1866667,15.6866667 L10.5686667,15.3046667 C11.168,15.752 11.9006667,16 12.6666667,16 C13.9546667,16 15.1373333,15.294 15.7526667,14.1573333 C15.928,13.8333333 15.808,13.4293333 15.484,13.2533333 L15.484,13.2533333 Z"
                id="Path"
              ></path>
              <path
                d="M15.6913333,9.20466667 C15.5046667,9.12733333 15.2893333,9.17 15.1466667,9.31333333 L14.7646667,9.69533333 C14.1653333,9.248 13.4326667,9 12.6666667,9 C11.376,9 10.1933333,9.70933333 9.57933333,10.8506667 C9.40533333,11.1753333 9.52666667,11.5793333 9.85066667,11.7533333 C9.95133333,11.8073333 10.0593333,11.8326667 10.166,11.8326667 C10.4033333,11.8326667 10.6333333,11.7053333 10.754,11.482 C11.1346667,10.7733333 11.868,10.3333333 12.6666667,10.3333333 C13.074,10.3333333 13.46,10.4566667 13.7973333,10.6626667 L13.48,10.98 C13.3373333,11.1226667 13.294,11.338 13.3713333,11.5246667 C13.4486667,11.7113333 13.6313333,11.8333333 13.8333333,11.8333333 L15.5,11.8333333 C15.776,11.8333333 16,11.6093333 16,11.3333333 L16,9.66666667 C16,9.46466667 15.878,9.282 15.6913333,9.20466667 L15.6913333,9.20466667 Z"
                id="Path"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>7EE165D5-630A-4E86-A1C4-29F3F51C9CA8</title>
      <defs>
        <rect id="path-1" x="0" y="0" width="16" height="16"></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-931.000000, -4879.000000)">
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <g id="icon/close" transform="translate(787.000000, 17.000000)">
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
              </mask>
              <g id="Canvas"></g>
              <path
                d="M12.6579062,4.48652005 C12.8121168,4.33230953 12.8121168,4.08230953 12.6579062,3.928099 L11.8184397,3.08863248 C11.6642292,2.93442195 11.4142292,2.93442195 11.2600187,3.08863248 L7.90850887,6.44014228 C7.80587729,6.54277386 7.63903518,6.54277386 7.53640361,6.44014228 L4.28268454,3.18642322 C4.12847401,3.03221269 3.87847401,3.03221269 3.72426349,3.18642322 L2.89315378,4.01753292 C2.73894325,4.17174345 2.73894325,4.42174345 2.89315378,4.57595398 L6.14687285,7.82967304 C6.24950443,7.93230462 6.24950443,8.09914673 6.14687285,8.2017783 L2.8710713,11.4775798 C2.71686078,11.6317904 2.71686078,11.8817904 2.8710713,12.0360009 L3.71053783,12.8754674 C3.86474835,13.0296779 4.11474835,13.0296779 4.26895888,12.8754674 L7.54476042,9.59966588 C7.647392,9.4970343 7.81423411,9.4970343 7.91686568,9.59966588 L11.2821011,12.9649013 C11.4363117,13.1191119 11.6863117,13.1191119 11.8405222,12.9649013 L12.6716319,12.1337916 C12.8258424,11.9795811 12.8258424,11.7295811 12.6716319,11.5753706 L9.30639644,8.21013512 C9.20376486,8.10750354 9.20376486,7.94066144 9.30639644,7.83802986 L12.6579062,4.48652005 Z"
                id="add"
                fill="#001E3C"
                mask="url(#mask-2)"
                transform="translate(7.771352, 8.026767) rotate(-360.000000) translate(-7.771352, -8.026767) "
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>747AA358-3D95-4970-BA6E-18A282549F0E</title>
      <defs>
        <rect id="path-1" x="0" y="0" width="16" height="16"></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-1001.000000, -4879.000000)">
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <g
              id="icon/Add_default"
              transform="translate(857.000000, 17.000000)"
            >
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
              </mask>
              <g id="Canvas"></g>
              <path
                d="M12.6579062,4.48652005 C12.8121168,4.33230953 12.8121168,4.08230953 12.6579062,3.928099 L11.8184397,3.08863248 C11.6642292,2.93442195 11.4142292,2.93442195 11.2600187,3.08863248 L7.90850887,6.44014228 C7.80587729,6.54277386 7.63903518,6.54277386 7.53640361,6.44014228 L4.28268454,3.18642322 C4.12847401,3.03221269 3.87847401,3.03221269 3.72426349,3.18642322 L2.89315378,4.01753292 C2.73894325,4.17174345 2.73894325,4.42174345 2.89315378,4.57595398 L6.14687285,7.82967304 C6.24950443,7.93230462 6.24950443,8.09914673 6.14687285,8.2017783 L2.8710713,11.4775798 C2.71686078,11.6317904 2.71686078,11.8817904 2.8710713,12.0360009 L3.71053783,12.8754674 C3.86474835,13.0296779 4.11474835,13.0296779 4.26895888,12.8754674 L7.54476042,9.59966588 C7.647392,9.4970343 7.81423411,9.4970343 7.91686568,9.59966588 L11.2821011,12.9649013 C11.4363117,13.1191119 11.6863117,13.1191119 11.8405222,12.9649013 L12.6716319,12.1337916 C12.8258424,11.9795811 12.8258424,11.7295811 12.6716319,11.5753706 L9.30639644,8.21013512 C9.20376486,8.10750354 9.20376486,7.94066144 9.30639644,7.83802986 L12.6579062,4.48652005 Z"
                id="add"
                fill="#004092"
                mask="url(#mask-2)"
                transform="translate(7.771352, 8.026767) rotate(-45.000000) translate(-7.771352, -8.026767) "
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>864D43FD-92DB-46D3-982E-CC10A6CE56FD</title>
      <defs>
        <rect id="path-1" x="0" y="0" width="16" height="16"></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-1071.000000, -4879.000000)">
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <g
              id="icon/Add_secondary"
              transform="translate(927.000000, 17.000000)"
            >
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
              </mask>
              <g id="Canvas"></g>
              <path
                d="M12.6579062,4.48652005 C12.8121168,4.33230953 12.8121168,4.08230953 12.6579062,3.928099 L11.8184397,3.08863248 C11.6642292,2.93442195 11.4142292,2.93442195 11.2600187,3.08863248 L7.90850887,6.44014228 C7.80587729,6.54277386 7.63903518,6.54277386 7.53640361,6.44014228 L4.28268454,3.18642322 C4.12847401,3.03221269 3.87847401,3.03221269 3.72426349,3.18642322 L2.89315378,4.01753292 C2.73894325,4.17174345 2.73894325,4.42174345 2.89315378,4.57595398 L6.14687285,7.82967304 C6.24950443,7.93230462 6.24950443,8.09914673 6.14687285,8.2017783 L2.8710713,11.4775798 C2.71686078,11.6317904 2.71686078,11.8817904 2.8710713,12.0360009 L3.71053783,12.8754674 C3.86474835,13.0296779 4.11474835,13.0296779 4.26895888,12.8754674 L7.54476042,9.59966588 C7.647392,9.4970343 7.81423411,9.4970343 7.91686568,9.59966588 L11.2821011,12.9649013 C11.4363117,13.1191119 11.6863117,13.1191119 11.8405222,12.9649013 L12.6716319,12.1337916 C12.8258424,11.9795811 12.8258424,11.7295811 12.6716319,11.5753706 L9.30639644,8.21013512 C9.20376486,8.10750354 9.20376486,7.94066144 9.30639644,7.83802986 L12.6579062,4.48652005 Z"
                id="add"
                fill="#51BB25"
                mask="url(#mask-2)"
                transform="translate(7.771352, 8.026767) rotate(-45.000000) translate(-7.771352, -8.026767) "
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="16px"
      height="12px"
      viewBox="0 0 16 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>6A9AA863-1610-4325-84A6-E148950FE3F0</title>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Style-Sheet"
          transform="translate(-161.000000, -4951.000000)"
          fill="#004092"
          fill-rule="nonzero"
        >
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <g id="icon/message" transform="translate(17.000000, 89.000000)">
              <path
                d="M0,2 C0,0.8953125 0.8953125,0 2,0 L14,0 C15.103125,0 16,0.8953125 16,2 L16,10 C16,11.103125 15.103125,12 14,12 L2,12 C0.8953125,12 0,11.103125 0,10 L0,2 Z M1.5,2 L1.5,2.690625 L6.890625,7.115625 C7.534375,7.646875 8.465625,7.646875 9.109375,7.115625 L14.5,2.690625 L14.5,1.971875 C14.5,1.725 14.275,1.471875 14,1.471875 L2,1.471875 C1.72375,1.471875 1.5,1.725 1.5,1.971875 L1.5,2 Z M1.5,4.63125 L1.5,10 C1.5,10.275 1.72375,10.5 2,10.5 L14,10.5 C14.275,10.5 14.5,10.275 14.5,10 L14.5,4.63125 L10.0625,8.275 C8.8625,9.259375 7.1375,9.259375 5.909375,8.275 L1.5,4.63125 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>8A989F4D-E32F-4FB9-BE63-D5C8569DC1AA</title>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Style-Sheet"
          transform="translate(-231.000000, -4949.000000)"
          fill="#004092"
        >
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <g id="icon/attach" transform="translate(87.000000, 87.000000)">
              <path
                d="M8,14.8571429 C6.42209499,14.8571429 5.14285739,13.5777143 5.14285739,12 L5.14285739,2.856 C5.14285739,2.40171429 5.32342872,1.96571429 5.6445714,1.64457143 C5.96571409,1.32342857 6.40152357,1.14285714 6.8559999,1.14285714 L6.85828561,1.14285714 C7.80457139,1.14285714 8.57142869,1.90971429 8.57142869,2.856 L8.57142869,10.8582857 C8.57142869,11.1731429 8.31619054,11.4285714 8.00114271,11.4285714 L8,11.4285714 C7.68457145,11.4285714 7.42857102,11.1725714 7.42857102,10.8571429 L7.42857102,4 C7.42857102,3.68457143 7.17257116,3.42857143 6.85714276,3.42857143 C6.54171435,3.42857143 6.28571449,3.68457143 6.28571449,4 L6.28571449,10.8571429 C6.28571449,11.804 7.05333351,12.5714286 8,12.5714286 L8.00114271,12.5714286 C8.94742849,12.5714286 9.71428522,11.8045714 9.71428522,10.8582857 L9.71428522,2.856 C9.71428522,1.27885714 8.4354282,0 6.85828561,0 L6.8559999,0 C6.09866659,0 5.37219041,0.301142857 4.83657127,0.836571429 C4.30095235,1.372 4,2.09828571 4,2.856 L4,12 C4,14.2091429 5.79085704,16 8,16 C9.06095243,16 10.0780947,15.5788571 10.8285709,14.8285714 C11.5786665,14.0782857 12,13.0611429 12,12 C12,8.63371429 12,4 12,4 C12,3.68457143 11.7439996,3.42857143 11.4285712,3.42857143 C11.1131428,3.42857143 10.8571423,3.68457143 10.8571423,4 L10.8571423,12 C10.8571423,12.7577143 10.5561905,13.4845714 10.0201902,14.0205714 C9.48457106,14.556 8.75771431,14.8571429 8,14.8571429 Z"
                id="path2"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="14px"
      height="14px"
      viewBox="0 0 14 14"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>EEF469A6-4179-4BB7-8AC5-2A32E9898B51</title>
      <defs>
        <rect
          id="path-1"
          x="0"
          y="0"
          width="13.3333333"
          height="13.3333333"
        ></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-302.000000, -4950.000000)">
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <g id="icon/Printer" transform="translate(157.000000, 87.000000)">
              <g transform="translate(1.333333, 1.333333)">
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1"></use>
                </mask>
                <g id="Canvas"></g>
                <path
                  d="M1.77777778,3.61111111 L3,3.61111111 L3,0.555555556 L10.3333333,0.555555556 L10.3333333,3.61111111 L11.5555556,3.61111111 C12.2305889,3.61111111 12.7777778,4.15831833 12.7777778,4.83333333 L12.7777778,9.72222222 C12.7777778,10.3972556 12.2305889,10.9444444 11.5555556,10.9444444 L10.3333333,10.9444444 L10.3333333,12.7777778 L3,12.7777778 L3,10.9444444 L1.77777778,10.9444444 C1.10276278,10.9444444 0.555555556,10.3972556 0.555555556,9.72222222 L0.555555556,4.83333333 C0.555555556,4.15831833 1.10276278,3.61111111 1.77777778,3.61111111 Z M9.11111111,3.61111111 L4.22222222,3.61111111 L4.22222222,1.77777778 L9.11111111,1.77777778 L9.11111111,3.61111111 Z M11.5555556,4.83333333 L11.5555556,9.72222222 L10.3333333,9.72222222 L10.3333333,8.5 L3,8.5 L3,9.72222222 L1.77777778,9.72222222 L1.77777778,4.83333333 L11.5555556,4.83333333 Z M9.11111111,9.72222222 L4.22222222,9.72222222 L4.22222222,11.5555556 L9.11111111,11.5555556 L9.11111111,9.72222222 Z M10.9444444,6.05555556 C10.9444444,5.71803889 10.67085,5.44444444 10.3333333,5.44444444 C9.99581667,5.44444444 9.72222222,5.71803889 9.72222222,6.05555556 C9.72222222,6.39307222 9.99581667,6.66666667 10.3333333,6.66666667 C10.67085,6.66666667 10.9444444,6.39307222 10.9444444,6.05555556 Z"
                  id="Shape"
                  fill="#004092"
                  mask="url(#mask-2)"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>85A4E273-4F40-424F-A750-78912D953847</title>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Style-Sheet"
          transform="translate(-371.000000, -4949.000000)"
          fill="#004092"
          fill-rule="nonzero"
        >
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <g id="icon/excel" transform="translate(227.000000, 87.000000)">
              <path
                d="M13.4643229,3.55335937 L11.3264844,1.51242187 C10.9807292,1.18435156 10.5138021,1 10.0296875,1 L4.83333333,1 C3.82070312,1 3,1.78339844 3,2.75 L3.0001862,13.25 C3.0001862,14.2163281 3.82088932,15 4.83351953,15 L12.1666667,15 C13.175,15 14,14.2125 14,13.25 L14,4.78984375 C14,4.32773438 13.8080729,3.88203125 13.4643229,3.55335937 Z M12.625,13.25 C12.625,13.4916094 12.4197813,13.6875 12.1666667,13.6875 L4.83390625,13.6875 C4.58073438,13.6875 4.37557292,13.4916094 4.37557292,13.25 L4.375,2.75355469 C4.375,2.51194531 4.58021875,2.31605469 4.83333333,2.31605469 L9.41666667,2.31605469 L9.41666667,4.5 C9.41666667,4.98316406 9.82716146,5.375 10.3333333,5.375 L12.5992188,5.375 L12.5992188,13.25 L12.625,13.25 Z M9.56276042,7.37929688 L8.5,8.68085938 L7.43723958,7.37929688 C7.20520833,7.0921875 6.77552083,7.04023438 6.47473958,7.26445313 C6.17395833,7.4859375 6.11953125,7.89882813 6.35442708,8.1859375 L7.62916667,9.75 L6.35356771,11.3154297 C6.11993229,11.6017188 6.17453125,12.0143359 6.47353646,12.2366406 C6.60078125,12.3285156 6.746875,12.375 6.87005208,12.375 C7.07504167,12.375 7.27825521,12.2878281 7.41346354,12.1220703 L8.5,10.8191406 L9.56161458,12.1220703 C9.69739583,12.2875 9.90078125,12.375 10.1041667,12.375 C10.2509766,12.375 10.3995052,12.3297188 10.5258333,12.2365859 C10.8248958,12.014418 10.8793229,11.6016641 10.6458021,11.315375 L9.37083333,9.75 L10.6464323,8.18457031 C10.8800677,7.89828125 10.8254687,7.48566406 10.5264635,7.26335938 C10.2244792,7.04023438 9.79479167,7.0921875 9.56276042,7.37929688 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="14px"
      height="15px"
      viewBox="0 0 14 15"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>F3302508-28CE-4BA0-A440-C5BC50D8B52C</title>
      <defs>
        <path
          d="M13.125,1.3125 C13.371095,1.3125 13.5784497,1.39680905 13.7470703,1.56542969 C13.9156909,1.73405032 14,1.94140502 14,2.1875 L14,13.125 C14,13.3619804 13.9156909,13.5670564 13.7470703,13.7402344 C13.5784497,13.9134123 13.371095,14 13.125,14 L0.875,14 C0.62890502,14 0.421550322,13.9134123 0.252929688,13.7402344 C0.0843090527,13.5670564 0,13.3619804 0,13.125 L0,2.1875 C0,1.94140502 0.0843090527,1.73405032 0.252929688,1.56542969 C0.421550322,1.39680905 0.62890502,1.3125 0.875,1.3125 L4.375,1.3125 L4.375,0.4375 C4.375,0.319009824 4.41829384,0.216471787 4.50488281,0.129882812 C4.59147179,0.0432938379 4.69400982,0 4.8125,0 C4.93099018,0 5.03352821,0.0432938379 5.12011719,0.129882812 C5.20670616,0.216471787 5.25,0.319009824 5.25,0.4375 L5.25,1.3125 L8.75,1.3125 L8.75,0.4375 C8.75,0.319009824 8.79329384,0.216471787 8.87988281,0.129882812 C8.96647179,0.0432938379 9.06900982,0 9.1875,0 C9.30599018,0 9.40852821,0.0432938379 9.49511719,0.129882812 C9.58170616,0.216471787 9.625,0.319009824 9.625,0.4375 L9.625,1.3125 L13.125,1.3125 Z M13.125,13.125 L13.125,2.1875 L9.625,2.1875 L9.625,2.625 C9.625,2.74349018 9.58170616,2.84602821 9.49511719,2.93261719 C9.40852821,3.01920616 9.30599018,3.0625 9.1875,3.0625 C9.06900982,3.0625 8.96647179,3.01920616 8.87988281,2.93261719 C8.79329384,2.84602821 8.75,2.74349018 8.75,2.625 L8.75,2.1875 L5.25,2.1875 L5.25,2.625 C5.25,2.74349018 5.20670616,2.84602821 5.12011719,2.93261719 C5.03352821,3.01920616 4.93099018,3.0625 4.8125,3.0625 C4.69400982,3.0625 4.59147179,3.01920616 4.50488281,2.93261719 C4.41829384,2.84602821 4.375,2.74349018 4.375,2.625 L4.375,2.1875 L0.875,2.1875 L0.875,13.125 L13.125,13.125 Z M10.0625,7 C9.94400982,7 9.84147179,6.95670616 9.75488281,6.87011719 C9.66829384,6.78352821 9.625,6.68099018 9.625,6.5625 L9.625,5.6875 C9.625,5.56900982 9.66829384,5.46647179 9.75488281,5.37988281 C9.84147179,5.29329384 9.94400982,5.25 10.0625,5.25 L10.9375,5.25 C11.0559902,5.25 11.1585282,5.29329384 11.2451172,5.37988281 C11.3317062,5.46647179 11.375,5.56900982 11.375,5.6875 L11.375,6.5625 C11.375,6.68099018 11.3317062,6.78352821 11.2451172,6.87011719 C11.1585282,6.95670616 11.0559902,7 10.9375,7 L10.0625,7 Z M10.0625,10.5 C9.94400982,10.5 9.84147179,10.4567062 9.75488281,10.3701172 C9.66829384,10.2835282 9.625,10.1809902 9.625,10.0625 L9.625,9.1875 C9.625,9.06900982 9.66829384,8.96647179 9.75488281,8.87988281 C9.84147179,8.79329384 9.94400982,8.75 10.0625,8.75 L10.9375,8.75 C11.0559902,8.75 11.1585282,8.79329384 11.2451172,8.87988281 C11.3317062,8.96647179 11.375,9.06900982 11.375,9.1875 L11.375,10.0625 C11.375,10.1809902 11.3317062,10.2835282 11.2451172,10.3701172 C11.1585282,10.4567062 11.0559902,10.5 10.9375,10.5 L10.0625,10.5 Z M7.4375,8.75 C7.55599018,8.75 7.65852821,8.79329384 7.74511719,8.87988281 C7.83170616,8.96647179 7.875,9.06900982 7.875,9.1875 L7.875,10.0625 C7.875,10.1809902 7.83170616,10.2835282 7.74511719,10.3701172 C7.65852821,10.4567062 7.55599018,10.5 7.4375,10.5 L6.5625,10.5 C6.44400982,10.5 6.34147179,10.4567062 6.25488281,10.3701172 C6.16829384,10.2835282 6.125,10.1809902 6.125,10.0625 L6.125,9.1875 C6.125,9.06900982 6.16829384,8.96647179 6.25488281,8.87988281 C6.34147179,8.79329384 6.44400982,8.75 6.5625,8.75 L7.4375,8.75 Z M7.4375,5.25 C7.55599018,5.25 7.65852821,5.29329384 7.74511719,5.37988281 C7.83170616,5.46647179 7.875,5.56900982 7.875,5.6875 L7.875,6.5625 C7.875,6.68099018 7.83170616,6.78352821 7.74511719,6.87011719 C7.65852821,6.95670616 7.55599018,7 7.4375,7 L6.5625,7 C6.44400982,7 6.34147179,6.95670616 6.25488281,6.87011719 C6.16829384,6.78352821 6.125,6.68099018 6.125,6.5625 L6.125,5.6875 C6.125,5.56900982 6.16829384,5.46647179 6.25488281,5.37988281 C6.34147179,5.29329384 6.44400982,5.25 6.5625,5.25 L7.4375,5.25 Z M3.9375,5.25 C4.05599018,5.25 4.15852821,5.29329384 4.24511719,5.37988281 C4.33170616,5.46647179 4.375,5.56900982 4.375,5.6875 L4.375,6.5625 C4.375,6.68099018 4.33170616,6.78352821 4.24511719,6.87011719 C4.15852821,6.95670616 4.05599018,7 3.9375,7 L3.0625,7 C2.94400982,7 2.84147179,6.95670616 2.75488281,6.87011719 C2.66829384,6.78352821 2.625,6.68099018 2.625,6.5625 L2.625,5.6875 C2.625,5.56900982 2.66829384,5.46647179 2.75488281,5.37988281 C2.84147179,5.29329384 2.94400982,5.25 3.0625,5.25 L3.9375,5.25 Z M3.9375,8.75 C4.05599018,8.75 4.15852821,8.79329384 4.24511719,8.87988281 C4.33170616,8.96647179 4.375,9.06900982 4.375,9.1875 L4.375,10.0625 C4.375,10.1809902 4.33170616,10.2835282 4.24511719,10.3701172 C4.15852821,10.4567062 4.05599018,10.5 3.9375,10.5 L3.0625,10.5 C2.94400982,10.5 2.84147179,10.4567062 2.75488281,10.3701172 C2.66829384,10.2835282 2.625,10.1809902 2.625,10.0625 L2.625,9.1875 C2.625,9.06900982 2.66829384,8.96647179 2.75488281,8.87988281 C2.84147179,8.79329384 2.94400982,8.75 3.0625,8.75 L3.9375,8.75 Z"
          id="path-3"
        ></path>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-442.000000, -4949.000000)">
          <g id="Group-20" transform="translate(144.000000, 4862.000000)">
            <g id="icon/calender" transform="translate(298.000000, 87.875000)">
              <mask id="mask-3" fill="white">
                <use xlink:href="#path-3"></use>
              </mask>
              <use
                id="calendar---simple-line-icons-copy"
                fill="#001E3C"
                xlink:href="#path-3"
              ></use>
              <g id="colors/white" mask="url(#mask-3)" fill="#001E3C">
                <g transform="translate(0.000000, 0.125000)" id="Rectangle-3">
                  <rect x="0" y="0" width="14" height="14"></rect>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</div>

<div class="card d-flex flex-row">
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>CBDFCD56-E635-4238-9E2F-6D19775027EB</title>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Style-Sheet"
          transform="translate(-157.000000, -5051.000000)"
          fill="#004092"
          fill-rule="nonzero"
        >
          <g id="Group-21" transform="translate(144.000000, 5038.000000)">
            <g
              id="icon/invoice_edit"
              transform="translate(13.000000, 13.000000)"
            >
              <g
                id="money-check-pen-regular"
                transform="translate(1.000000, 5.000000)"
              >
                <path
                  d="M1.72533698,2.28651012 L1.72533698,11.4325506 C1.72533698,11.7469457 1.98269975,12.0041781 2.30044931,12.0041781 L12.5194765,12.0041781 C12.3181871,12.2578378 12.1744091,12.5507969 12.0953311,12.8651921 L11.879664,13.7190607 L2.30044931,13.7190607 C1.02981051,13.7190607 0,12.6937038 0,11.4325506 L0,2.28651012 C0,1.02357054 1.02981051,0 2.30044931,0 L18.4035945,0 C19.672436,0 20.7040438,1.02357054 20.7040438,2.28651012 L20.7040438,4.59445626 C20.157687,4.66590971 19.6328971,4.9088514 19.2159406,5.32685404 L18.9787068,5.55907772 L18.9787068,2.28651012 C18.9787068,1.97211497 18.7199062,1.71488259 18.4035945,1.71488259 L2.30044931,1.71488259 C1.98269975,1.71488259 1.72533698,1.97211497 1.72533698,2.28651012 Z M11.7898027,7.43115788 C12.2678648,7.43115788 12.6524712,7.81343379 12.6524712,8.28859917 C12.6524712,8.76376455 12.2678648,9.14604046 11.7898027,9.14604046 L4.31334245,9.14604046 C3.83528033,9.14604046 3.45067396,8.76376455 3.45067396,8.28859917 C3.45067396,7.81343379 3.83528033,7.43115788 4.31334245,7.43115788 L11.7898027,7.43115788 Z M3.45067396,4.858834 C3.45067396,4.38366861 3.83528033,4.0013927 4.31334245,4.0013927 L15.2404767,4.0013927 C15.7185388,4.0013927 16.1031451,4.38366861 16.1031451,4.858834 C16.1031451,5.33399938 15.7185388,5.71627529 15.2404767,5.71627529 L4.31334245,5.71627529 C3.83528033,5.71627529 3.45067396,5.33399938 3.45067396,4.858834 Z M22.5767533,6.6487427 C23.1410822,7.20607954 23.1410822,8.10996557 22.5767533,8.67087508 L21.5199844,9.72124066 L18.9715179,7.1846435 L20.0282868,6.13427792 C20.5890213,5.57694108 21.4984177,5.57694108 22.0627466,6.13427792 L22.5767533,6.6487427 Z M13.5115452,12.5793783 L18.1555773,7.99564006 L20.7076382,10.5286645 L16.0636062,15.1445568 C15.9162336,15.2910364 15.7293221,15.3946439 15.5280328,15.4446613 L13.3677671,15.9841348 C13.1700723,16.0305795 12.9651885,15.9734168 12.8214104,15.8340826 C12.6776324,15.6911757 12.6201211,15.4839607 12.6704434,15.2588824 L13.2096113,13.1402878 C13.2599336,12.9402182 13.3641727,12.7580119 13.5115452,12.5793783 L13.5115452,12.5793783 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>498A4435-42FA-4DDB-98EF-FA237E83C115</title>
      <defs>
        <rect id="path-4" x="0" y="0" width="20" height="20"></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-229.000000, -5053.000000)">
          <g id="Group-21" transform="translate(144.000000, 5038.000000)">
            <g id="icon/print" transform="translate(83.000000, 13.000000)">
              <g id="icon/Printer" transform="translate(2.000000, 2.000000)">
                <mask id="mask-4" fill="white">
                  <use xlink:href="#path-4"></use>
                </mask>
                <g id="Canvas"></g>
                <path
                  d="M2.66666667,5.41666667 L4.5,5.41666667 L4.5,0.833333333 L15.5,0.833333333 L15.5,5.41666667 L17.3333333,5.41666667 C18.3458833,5.41666667 19.1666667,6.2374775 19.1666667,7.25 L19.1666667,14.5833333 C19.1666667,15.5958833 18.3458833,16.4166667 17.3333333,16.4166667 L15.5,16.4166667 L15.5,19.1666667 L4.5,19.1666667 L4.5,16.4166667 L2.66666667,16.4166667 C1.65414417,16.4166667 0.833333333,15.5958833 0.833333333,14.5833333 L0.833333333,7.25 C0.833333333,6.2374775 1.65414417,5.41666667 2.66666667,5.41666667 Z M13.6666667,5.41666667 L6.33333333,5.41666667 L6.33333333,2.66666667 L13.6666667,2.66666667 L13.6666667,5.41666667 Z M17.3333333,7.25 L17.3333333,14.5833333 L15.5,14.5833333 L15.5,12.75 L4.5,12.75 L4.5,14.5833333 L2.66666667,14.5833333 L2.66666667,7.25 L17.3333333,7.25 Z M13.6666667,14.5833333 L6.33333333,14.5833333 L6.33333333,17.3333333 L13.6666667,17.3333333 L13.6666667,14.5833333 Z M16.4166667,9.08333333 C16.4166667,8.57705833 16.006275,8.16666667 15.5,8.16666667 C14.993725,8.16666667 14.5833333,8.57705833 14.5833333,9.08333333 C14.5833333,9.58960833 14.993725,10 15.5,10 C16.006275,10 16.4166667,9.58960833 16.4166667,9.08333333 Z"
                  id="Shape"
                  fill="#004092"
                  mask="url(#mask-4)"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>00D76CC2-DEC9-4D4D-8CB8-5294D0252130</title>
      <defs>
        <rect id="path-5" x="0" y="0" width="24" height="24"></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-297.000000, -5051.000000)">
          <g id="Group-21" transform="translate(144.000000, 5038.000000)">
            <g id="icon/Edit" transform="translate(153.000000, 13.000000)">
              <mask id="mask-5" fill="white">
                <use xlink:href="#path-5"></use>
              </mask>
              <g id="Canvas"></g>
              <path
                d="M3.24611557,17.2609798 L3.00415798,19.9225126 C2.94830016,20.536949 3.46305014,21.0517001 4.07748644,20.9958422 L6.73902022,20.7538844 L17.9162987,9.5766059 L14.4233941,6.08370126 L3.24611557,17.2609798 Z M20.7106384,6.78226619 C21.0964537,6.39645096 21.096454,5.77091991 20.7106384,5.38510434 L18.6148957,3.28936155 C18.2290801,2.90354598 17.603549,2.90354632 17.2177338,3.28936155 L15.121975,5.38512033 L18.6148797,8.87802497 L20.7106384,6.78226619 Z"
                id="Edit"
                fill="#004092"
                mask="url(#mask-5)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>EEA77C4D-4840-43D9-867A-F2B5ABAE25C3</title>
      <defs>
        <rect id="path-6" x="0" y="0" width="24" height="24"></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-367.000000, -5051.000000)">
          <g id="Group-21" transform="translate(144.000000, 5038.000000)">
            <g id="icon/Trash" transform="translate(223.000000, 13.000000)">
              <mask id="mask-6" fill="white">
                <use xlink:href="#path-6"></use>
              </mask>
              <g id="Canvas"></g>
              <path
                d="M9,2 C7.89699996,2 7,2.89699996 7,4 L7,5 L3,5 L3,7 L5,7 L5,20 C5,21.103 5.89699996,22 7,22 L17,22 C18.103,22 19,21.103 19,20 L19,7 L21,7 L21,5 L17,5 L17,4 C17,2.89699996 16.103,2 15,2 L9,2 Z M15,4 L15,5 L9,5 L9,4 L15,4 Z M7,20 L7,7 L17,7 L17,20 L7,20 Z M11,9 L11,18 L9,18 L9,9 L11,9 Z M15,9 L15,18 L13,18 L13,9 L15,9 Z"
                id="Trash"
                fill="#DC3545"
                mask="url(#mask-6)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>3560E87A-77E6-421E-8213-C44D9101FE4C</title>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Style-Sheet"
          transform="translate(-437.000000, -5051.000000)"
          fill="#004092"
          fill-rule="nonzero"
        >
          <g id="Group-21" transform="translate(144.000000, 5038.000000)">
            <g id="icon/go_detail" transform="translate(293.000000, 13.000000)">
              <path
                d="M11.99701,0 C5.38109162,0 0,5.38905863 0,12.0049921 C0,18.6208869 5.38109162,24.0019974 11.99701,24.0019974 C18.6129315,24.0019974 24,18.6208869 24,12.0049921 C24,5.38905863 18.6129315,0 11.99701,0 Z M11.99701,2.04167897 C17.5095116,2.04167897 21.9582956,6.49246658 21.9582956,12.0049921 C21.9582956,17.517479 17.5095116,21.9582735 11.99701,21.9582735 C6.48451153,21.9582735 2.04170474,17.517479 2.04170474,12.0049921 C2.04170474,6.49246658 6.48451153,2.04167897 11.99701,2.04167897 Z M10.9562183,6.8867503 C10.6916984,6.89516692 10.4407827,7.00597225 10.2563761,7.1958033 L6.17097283,11.2812062 C5.77512427,11.6794167 5.77512427,12.3225421 6.17097283,12.7207526 L10.2563761,16.8041877 C10.5095793,17.0808153 10.894058,17.1963625 11.2578087,17.1051479 C11.6215594,17.0139332 11.9060245,16.7306407 11.9987408,16.3672699 C12.0914571,16.003899 11.9774989,15.6189463 11.7019196,15.3646027 L9.35914274,13.0218575 L17.0913023,13.0218575 C17.6463932,13.0096953 18.0900389,12.5562228 18.0900389,12.0009987 C18.0900389,11.4457746 17.6463932,10.992302 17.0913023,10.9801399 L9.3671187,10.9801399 L11.7019196,8.64333656 C12.0075289,8.34983076 12.1000802,7.89806062 11.9345037,7.50802587 C11.7689272,7.11799112 11.3796416,6.87076914 10.9562183,6.8867503 L10.9562183,6.8867503 Z"
                id="path3553"
                transform="translate(12.000000, 12.000999) scale(-1, 1) translate(-12.000000, -12.000999) "
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="41px"
      height="40px"
      viewBox="0 0 41 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>0CBEC169-8CEE-40C5-B006-AC3E5B4F90A8</title>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Style-Sheet"
          transform="translate(-499.000000, -5043.000000)"
          fill="#004092"
          fill-rule="nonzero"
        >
          <g id="Group-21" transform="translate(144.000000, 5038.000000)">
            <g id="icon/send_mail" transform="translate(355.000000, 5.000000)">
              <g id="Group" transform="translate(5.050763, 3.030458)">
                <path
                  d="M29.6733629,12.667979 L22.6450012,5.63961034 C21.6737794,4.66838766 20.1020144,4.66838766 19.1307927,5.63961034 L7.41691163,17.3535028 C6.44574514,18.3246703 6.44563465,19.8964368 7.41691163,20.8676595 L14.4452734,27.8960281 C15.4164951,28.8672508 16.9882049,28.867306 17.9594819,27.8960281 L29.6734182,16.1821357 C30.6445847,15.2109682 30.6446399,13.6391464 29.6733629,12.667979 Z M21.7162058,7.05360363 L28.2593158,13.59672 L21.7162058,13.59672 L21.7162058,7.05360363 Z M15.3740687,26.4820348 L8.83090353,19.9389185 L15.3740687,19.9389185 L15.3740687,26.4820348 L15.3740687,26.4820348 Z M8.83084829,18.2878786 L20.0651675,7.05354838 L20.0651675,17.4540446 C20.0651675,17.9107916 19.6880809,18.2878786 19.2313344,18.2878786 L8.83084829,18.2878786 L8.83084829,18.2878786 Z M17.025107,26.4820901 L17.025107,19.9389185 L19.2313344,19.9389185 C20.6015188,19.9389185 21.7162058,18.8241751 21.7162058,17.4540446 L21.7162058,15.2478151 L28.259371,15.2478151 L17.025107,26.4820901 Z"
                  id="Shape"
                  transform="translate(18.545151, 16.767830) rotate(-315.000000) translate(-18.545151, -16.767830) "
                ></path>
                <path
                  d="M7.83756299,12.0069555 C7.51406179,11.683454 6.98958769,11.683454 6.66614174,12.0069555 L1.62900275,17.0441547 C1.30550156,17.3676562 1.30550156,17.8920756 1.62900275,18.2155218 C1.9524487,18.5390234 2.47697805,18.5390234 2.80036876,18.2155218 L7.83756299,13.1783227 C8.16106418,12.8548212 8.16106418,12.3304018 7.83756299,12.0069555 Z"
                  id="Path"
                  transform="translate(4.733283, 15.111239) rotate(-315.000000) translate(-4.733283, -15.111239) "
                ></path>
                <path
                  d="M8.32279326,9.8651378 C7.99929206,9.54158105 7.47481796,9.54158105 7.15142725,9.8651378 L4.45702027,12.5595474 C4.13351908,12.8830489 4.13351908,13.4074683 4.45702027,13.7309146 C4.78046622,14.0544161 5.30499557,14.0544161 5.62838628,13.7309146 L8.32279326,11.0365049 C8.64623921,10.7130587 8.64623921,10.1886393 8.32279326,9.8651378 Z"
                  id="Path"
                  transform="translate(6.389886, 11.798005) rotate(-315.000000) translate(-6.389886, -11.798005) "
                ></path>
                <path
                  d="M7.83759363,15.3200739 C7.51409243,14.9965724 6.98961833,14.9965724 6.66617238,15.3201291 L1.62897815,20.3573283 C1.30547695,20.6808298 1.30547695,21.2052492 1.62897815,21.5286954 C1.9524241,21.8521969 2.47695344,21.8521969 2.80034415,21.5286954 L7.83753838,16.4914963 C8.16103958,16.1679948 8.16103958,15.6435754 7.83759363,15.3200739 Z"
                  id="Path"
                  transform="translate(4.733262, 18.424388) rotate(-315.000000) translate(-4.733262, -18.424388) "
                ></path>
                <path
                  d="M8.32272862,19.8047167 C7.99928267,19.4812152 7.47480857,19.4812152 7.15136262,19.8047167 L4.45695564,22.4991263 C4.13345445,22.8226278 4.13345445,23.3470472 4.45695564,23.6704935 C4.78040159,23.993995 5.30493094,23.993995 5.62832165,23.6704935 L8.32272862,20.9760838 C8.64622982,20.6525823 8.64622982,20.128163 8.32272862,19.8047167 Z"
                  id="Path"
                  transform="translate(6.389842, 21.737605) rotate(-315.000000) translate(-6.389842, -21.737605) "
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>2CDE1E2E-9331-43B5-BCD0-09FC47AFCE21</title>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Style-Sheet"
          transform="translate(-577.000000, -5051.000000)"
          fill="#004092"
          fill-rule="nonzero"
        >
          <g id="Group-21" transform="translate(144.000000, 5038.000000)">
            <g
              id="icon/password_reset"
              transform="translate(433.000000, 13.000000)"
            >
              <path
                d="M13.75,7 L13,7 L13,5 C13,2.243 10.757,0 8,0 C5.243,0 3,2.243 3,5 L3,7 L2.25,7 C1.01,7 0,8.01 0,9.25 L0,17.75 C0,18.99 1.01,20 2.25,20 L12.05,20 C12.15,19.43 12.44,18.92 12.84,18.52 C12.18,17.62 12.04,16.38 12.61,15.33 C13.38,13.9 14.58,12.8 16,12.16 L16,9.25 C16,8.01 14.99,7 13.75,7 Z M5,5 C5,3.346 6.346,2 8,2 C9.654,2 11,3.346 11,5 L11,7 L5,7 L5,5 Z"
                id="Shape"
              ></path>
              <path
                d="M23.226,19.88 C22.74,19.618 22.134,19.798 21.871,20.283 C21.297,21.342 20.197,22 19,22 C18.389,22 17.81,21.815 17.304,21.506 L17.78,21.03 C17.994,20.816 18.059,20.493 17.943,20.213 C17.827,19.933 17.553,19.75 17.25,19.75 L14.75,19.75 C14.336,19.75 14,20.086 14,20.5 L14,23 C14,23.303 14.183,23.577 14.463,23.693 C14.556,23.732 14.653,23.75 14.75,23.75 C14.945,23.75 15.137,23.674 15.28,23.53 L15.853,22.957 C16.752,23.628 17.851,24 19,24 C20.932,24 22.706,22.941 23.629,21.236 C23.892,20.75 23.712,20.144 23.226,19.88 L23.226,19.88 Z"
                id="Path"
              ></path>
              <path
                d="M23.537,13.807 C23.257,13.691 22.934,13.755 22.72,13.97 L22.147,14.543 C21.248,13.872 20.149,13.5 19,13.5 C17.064,13.5 15.29,14.564 14.369,16.276 C14.108,16.763 14.29,17.369 14.776,17.63 C14.927,17.711 15.089,17.749 15.249,17.749 C15.605,17.749 15.95,17.558 16.131,17.223 C16.702,16.16 17.802,15.5 19,15.5 C19.611,15.5 20.19,15.685 20.696,15.994 L20.22,16.47 C20.006,16.684 19.941,17.007 20.057,17.287 C20.173,17.567 20.447,17.75 20.75,17.75 L23.25,17.75 C23.664,17.75 24,17.414 24,17 L24,14.5 C24,14.197 23.817,13.923 23.537,13.807 L23.537,13.807 Z"
                id="Path"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="26px"
      height="26px"
      viewBox="0 0 26 26"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>A6B9A762-8D94-4D94-AC60-42C277AA51BC</title>
      <defs>
        <rect id="path-11" x="0" y="0" width="26" height="26"></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-646.000000, -5050.000000)">
          <g id="Group-21" transform="translate(144.000000, 5038.000000)">
            <g id="icon/close" transform="translate(502.000000, 12.000000)">
              <mask id="mask-11" fill="white">
                <use xlink:href="#path-11"></use>
              </mask>
              <g id="Canvas"></g>
              <path
                d="M20.5690977,7.29059509 C20.8196898,7.04000298 20.8196898,6.63375298 20.5690977,6.38316088 L19.2049646,5.01902778 C18.9543724,4.76843567 18.5481224,4.76843567 18.2975303,5.01902778 L12.8513269,10.4652312 C12.6845506,10.6320075 12.4134322,10.6320075 12.2466559,10.4652312 L6.95936238,5.17793773 C6.70877027,4.92734562 6.30252027,4.92734562 6.05192817,5.17793773 L4.70137489,6.528491 C4.45078279,6.7790831 4.45078279,7.1853331 4.70137489,7.43592521 L9.98866838,12.7232187 C10.1554447,12.889995 10.1554447,13.1611134 9.98866838,13.3278897 L4.66549087,18.6510673 C4.41489876,18.9016594 4.41489876,19.3079094 4.66549087,19.5585015 L6.02962397,20.9226346 C6.28021607,21.1732267 6.68646607,21.1732267 6.93705818,20.9226346 L12.2602357,15.5994571 C12.427012,15.4326807 12.6981304,15.4326807 12.8649067,15.5994571 L18.3334144,21.0679647 C18.5840065,21.3185568 18.9902565,21.3185568 19.2408486,21.0679647 L20.5914019,19.7174114 C20.841994,19.4668193 20.841994,19.0605693 20.5914019,18.8099772 L15.1228942,13.3414696 C14.9561179,13.1746933 14.9561179,12.9035748 15.1228942,12.7367985 L20.5690977,7.29059509 Z"
                id="add"
                fill="#001E3C"
                mask="url(#mask-11)"
                transform="translate(12.628446, 13.043496) rotate(-360.000000) translate(-12.628446, -13.043496) "
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>F3A856DD-B5E7-4779-8869-F7AFA5173D70</title>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Style-Sheet"
          transform="translate(-717.000000, -5051.000000)"
          fill="#B1B1B1"
          fill-rule="nonzero"
        >
          <g id="Group-21" transform="translate(144.000000, 5038.000000)">
            <path
              d="M596.977394,35.5005099 C596.977394,36.3286502 597.182816,37 596.355174,37 L573.910641,37 C573.082999,37 573,36.3286502 573,35.5005099 C573,34.6723696 573.082999,34.0010198 573.910641,34.0010198 L596.355174,34.0010198 C597.182816,34.0010198 596.977394,34.6723696 596.977394,35.5005099 Z M583.929056,30.7503127 C584.221702,31.043135 584.605153,31.1895227 584.988697,31.1895227 C585.372148,31.1895227 585.755786,31.0430881 586.048339,30.7503127 L591.921541,25 C592.506787,24.4144023 591.943172,23.9025631 591.357927,23.3169653 C590.772682,22.7313676 590.387456,22.2937952 589.802211,22.879393 L586.487284,26.0699354 L586.487284,13.701317 C586.487284,12.8731767 585.816339,13.0081582 584.988697,13.0081582 C584.161056,13.0081582 583.49011,12.8731767 583.49011,13.701317 L583.49011,26.0699354 L580.275084,22.879393 C579.689838,22.2937952 579.204713,22.7313676 578.619468,23.3169653 C578.034223,23.9025631 577.570508,24.4144023 578.155754,25 L583.929056,30.7503127 Z"
              id="icon/download"
              style="mix-blend-mode: normal"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="24px"
      height="18px"
      viewBox="0 0 24 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>E82361BF-1878-4DD3-B6AE-F0D2AEAE356D</title>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Style-Sheet"
          transform="translate(-787.000000, -5054.000000)"
          fill="#004092"
          fill-rule="nonzero"
        >
          <g id="Group-21" transform="translate(144.000000, 5038.000000)">
            <g id="icon/message" transform="translate(643.000000, 16.000000)">
              <path
                d="M0,3 C0,1.34296875 1.34296875,0 3,0 L21,0 C22.6546875,0 24,1.34296875 24,3 L24,15 C24,16.6546875 22.6546875,18 21,18 L3,18 C1.34296875,18 0,16.6546875 0,15 L0,3 Z M2.25,3 L2.25,4.0359375 L10.3359375,10.6734375 C11.3015625,11.4703125 12.6984375,11.4703125 13.6640625,10.6734375 L21.75,4.0359375 L21.75,2.9578125 C21.75,2.5875 21.4125,2.2078125 21,2.2078125 L3,2.2078125 C2.585625,2.2078125 2.25,2.5875 2.25,2.9578125 L2.25,3 Z M2.25,6.946875 L2.25,15 C2.25,15.4125 2.585625,15.75 3,15.75 L21,15.75 C21.4125,15.75 21.75,15.4125 21.75,15 L21.75,6.946875 L15.09375,12.4125 C13.29375,13.8890625 10.70625,13.8890625 8.8640625,12.4125 L2.25,6.946875 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="20px"
      height="24px"
      viewBox="0 0 20 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>3C46F594-72EC-4486-A51B-17BD1178F6AD</title>
      <defs>
        <rect id="path-6" x="0" y="0" width="20" height="20"></rect>
        <rect id="path-7" x="0" y="0" width="14" height="10"></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-859.000000, -5051.000000)">
          <g id="Group-21" transform="translate(144.000000, 5038.000000)">
            <g
              id="icon/fatura_dokumu_yazdır"
              transform="translate(715.000000, 13.000000)"
            >
              <g id="icon/Printer" transform="translate(0.000000, 4.000000)">
                <mask id="mask-6" fill="white">
                  <use xlink:href="#path-6"></use>
                </mask>
                <g id="Canvas"></g>
                <path
                  d="M2.66666667,5.41666667 L4.5,5.41666667 L4.5,5.5 L15.5,5.5 L15.5,5.41666667 L17.3333333,5.41666667 C18.3458833,5.41666667 19.1666667,6.2374775 19.1666667,7.25 L19.1666667,14.5833333 C19.1666667,15.5958833 18.3458833,16.4166667 17.3333333,16.4166667 L15.5,16.4166667 L15.5,19.1666667 L4.5,19.1666667 L4.5,16.4166667 L2.66666667,16.4166667 C1.65414417,16.4166667 0.833333333,15.5958833 0.833333333,14.5833333 L0.833333333,7.25 C0.833333333,6.2374775 1.65414417,5.41666667 2.66666667,5.41666667 Z M17.3333333,7.25 L17.3333333,14.5833333 L15.5,14.5833333 L15.5,12.75 L4.5,12.75 L4.5,14.5833333 L2.66666667,14.5833333 L2.66666667,7.25 L17.3333333,7.25 Z M13.6666667,14.5833333 L6.33333333,14.5833333 L6.33333333,17.3333333 L13.6666667,17.3333333 L13.6666667,14.5833333 Z M16.4166667,9.08333333 C16.4166667,8.57705833 16.006275,8.16666667 15.5,8.16666667 C14.993725,8.16666667 14.5833333,8.57705833 14.5833333,9.08333333 C14.5833333,9.58960833 14.993725,10 15.5,10 C16.006275,10 16.4166667,9.58960833 16.4166667,9.08333333 Z"
                  id="Shape"
                  fill="#004092"
                  mask="url(#mask-6)"
                ></path>
              </g>
              <g id="icon/invoice" transform="translate(3.000000, 0.000000)">
                <mask id="mask-7" fill="white">
                  <use xlink:href="#path-7"></use>
                </mask>
                <g id="Mask"></g>
                <g mask="url(#mask-7)" id="receipt-regular">
                  <g transform="translate(0.875000, 2.000000)">
                    <path
                      d="M9.40625,8.99855814 L2.84375,8.99855814 C2.7234375,8.99855814 2.625,9.1110432 2.625,9.24852494 L2.625,10.2483921 C2.625,10.3858738 2.7234375,10.4983589 2.84375,10.4983589 L9.40625,10.4983589 C9.5265625,10.4983589 9.625,10.3858738 9.625,10.2483921 L9.625,9.24852494 C9.625,9.1110432 9.5265625,8.99855814 9.40625,8.99855814 Z M10.959375,0.177854903 L9.76992187,1.15584998 L8.71445312,0.287215375 C8.25507812,-0.0908594004 7.64257812,-0.0908594004 7.18046875,0.287215375 L6.125,1.15584998 L5.06953125,0.287215375 C4.61172312,-0.09085453 3.99335501,-0.09085453 3.53554688,0.287215375 L2.48007812,1.15584998 L1.290625,0.177854903 C0.74921875,-0.265836156 0,0.174730318 0,0.934004454 L0,15.0665021 C0,15.8101533 0.741015625,16.2725918 1.290625,15.8226516 L2.48007812,14.8415319 L3.53554688,15.7101666 C3.99492188,16.0882413 4.60742188,16.0882413 5.06953125,15.7101666 L6.125,14.8415319 L7.18046875,15.7101666 C7.63984375,16.0882413 8.25507812,16.0882413 8.71445313,15.7101666 L9.76992187,14.8415319 L10.959375,15.819527 C11.5007813,16.2632181 12.25,15.8226516 12.25,15.0665021 L12.25,0.934004454 C12.25,0.187228658 11.5089844,-0.272085326 10.959375,0.177854903 Z M10.525,14.1452217 L9.46963068,13.1859742 L7.82107955,14.6857749 L6.17252841,13.1859742 L4.52397727,14.6857749 L2.87542614,13.1859742 L1.825,14.1452217 L1.825,2.24055319 L2.88036932,3.19980076 L4.52892045,1.7 L6.17747159,3.19980076 L7.82602273,1.7 L9.47457386,3.19980076 L10.525,2.24055319 L10.525,14.1452217 Z M9.40625,4.49902303 L2.84375,4.49902303 C2.7234375,4.49902303 2.625,4.61150808 2.625,4.74898982 L2.625,5.748857 C2.625,5.88633873 2.7234375,5.99882379 2.84375,5.99882379 L9.40625,5.99882379 C9.5265625,5.99882379 9.625,5.88633873 9.625,5.748857 L9.625,4.74898982 C9.625,4.61150808 9.5265625,4.49902303 9.40625,4.49902303 Z"
                      id="Shape"
                      fill="#004092"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="d-flex align-items-center justify-content-center m-r-15"
    style="
      height: 50px;
      width: 50px;
      border-radius: 5px;
      background-color: #efefef;
    "
  >
    <svg
      width="20px"
      height="24px"
      viewBox="0 0 20 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>4813D6B2-748A-4E98-8157-348B39A1298C</title>
      <defs>
        <rect id="path-8" x="0" y="0" width="20" height="20"></rect>
        <rect id="path-9" x="0" y="0" width="14" height="10"></rect>
      </defs>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet" transform="translate(-929.000000, -5051.000000)">
          <g id="Group-21" transform="translate(144.000000, 5038.000000)">
            <g
              id="icon/provizyon_dokuman_formu_yazdır"
              transform="translate(785.000000, 13.000000)"
            >
              <g id="icon/Printer" transform="translate(0.000000, 4.000000)">
                <mask id="mask-8" fill="white">
                  <use xlink:href="#path-8"></use>
                </mask>
                <g id="Canvas"></g>
                <path
                  d="M2.66666667,5.41666667 L4.5,5.41666667 L4.5,5.5 L15.5,5.5 L15.5,5.41666667 L17.3333333,5.41666667 C18.3458833,5.41666667 19.1666667,6.2374775 19.1666667,7.25 L19.1666667,14.5833333 C19.1666667,15.5958833 18.3458833,16.4166667 17.3333333,16.4166667 L15.5,16.4166667 L15.5,19.1666667 L4.5,19.1666667 L4.5,16.4166667 L2.66666667,16.4166667 C1.65414417,16.4166667 0.833333333,15.5958833 0.833333333,14.5833333 L0.833333333,7.25 C0.833333333,6.2374775 1.65414417,5.41666667 2.66666667,5.41666667 Z M17.3333333,7.25 L17.3333333,14.5833333 L15.5,14.5833333 L15.5,12.75 L4.5,12.75 L4.5,14.5833333 L2.66666667,14.5833333 L2.66666667,7.25 L17.3333333,7.25 Z M13.6666667,14.5833333 L6.33333333,14.5833333 L6.33333333,17.3333333 L13.6666667,17.3333333 L13.6666667,14.5833333 Z M16.4166667,9.08333333 C16.4166667,8.57705833 16.006275,8.16666667 15.5,8.16666667 C14.993725,8.16666667 14.5833333,8.57705833 14.5833333,9.08333333 C14.5833333,9.58960833 14.993725,10 15.5,10 C16.006275,10 16.4166667,9.58960833 16.4166667,9.08333333 Z"
                  id="Shape"
                  fill="#004092"
                  mask="url(#mask-8)"
                ></path>
              </g>
              <g id="icon/invoice" transform="translate(3.000000, 0.000000)">
                <mask id="mask-9" fill="white">
                  <use xlink:href="#path-9"></use>
                </mask>
                <g id="Mask"></g>
                <g mask="url(#mask-9)" id="file-alt-regular">
                  <g transform="translate(1.000000, 1.000000)">
                    <path
                      d="M9,6.625 L9,7.5 C9,7.70625 8.83125,7.875 8.625,7.875 L3.375,7.875 C3.16875,7.875 3,7.70625 3,7.5 L3,6.625 C3,6.41875 3.16875,6.25 3.375,6.25 L8.625,6.25 C8.83125,6.25 9,6.41875 9,6.625 Z M12,4.121875 L12,14.5 C12,15.328125 11.328125,16 10.5,16 L1.5,16 C0.671875,16 0,15.328125 0,14.5 L0,1.5 C0,0.671875 0.671875,0 1.5,0 L7.878125,0 C8.275,0 8.65625,0.159375 8.9375,0.440625 L11.559375,3.0625 C11.840625,3.340625 12,3.725 12,4.121875 Z M8,1.621875 L8,4 L10.378125,4 L8,1.621875 Z M10.3,14.5 L10.3,5.5 L7.19444444,5.5 C6.79729167,5.5 6.47777778,5.165625 6.47777778,4.75 L6.47777778,1.5 L1.7,1.5 L1.7,14.5 L10.3,14.5 Z"
                      id="Shape"
                      fill="#004092"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</div>

<h3>Table accordion</h3>
<div class="table-responsive">
  <table class="table-accordion table-striped">
    <thead>
      <tr>
        <th></th>
        <th scope="col">Teminat</th>
        <th scope="col">Kod</th>
        <th scope="col">Ad</th>
        <th scope="col">Ödenen Tutar (KDV'li)</th>
        <th scope="col">Ödenen Tutar (KDV'siz)</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="table-accordion-img">
          <img src="../../../../assets/images/ux-images/Chevron_Down.png" />
        </td>

        <td>Radyoloji</td>
        <td>10.0030</td>
        <td>Bronoskopi, Bronkoalveolar lavaj</td>
        <td>4.246,32</td>
        <td>4.000,00</td>
      </tr>
      <tr>
        <td class="res-table-accordion"></td>
        <td colspan="6" class="res-table-accordion">
          <div class="d-flex justify-content-start">
            <div class="d-flex mr-5">
              <span>bcx</span>:
              <span><b>bcx</b></span>
            </div>
            <div class="d-flex mr-5">
              <span>bcx</span>:
              <span><b>bcx</b></span>
            </div>

            <div class="d-flex mr-5">
              <span>bcx</span>:
              <span><b>bcx</b></span>
            </div>

            <div class="d-flex mr-5">
              <span>bcx</span>:
              <span><b>bcx</b></span>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
